import React from 'react';
import SelectionList from './SelectionList';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedProductType } from '../../Reducers/App/Selectors';
import { setSelectedProductType } from '../../Reducers/App/Actions';
import { SelectionListItem } from './SelectionList';

interface ProductTypeSelectorProps {
  title: string;
  items: SelectionListItem[];
}

const ProductTypeSelector: React.FC<ProductTypeSelectorProps> = (props) => {
  const dispatch = useDispatch();

  const handleClick = (item) => {
    dispatch(setSelectedProductType(item));
  };

  const selectedItem = useSelector(getSelectedProductType);

  return (
    <SelectionList
      items={props.items}
      title={props.title}
      onItemSelection={handleClick}
      selectedItem={selectedItem}
    />
  );
};

export default ProductTypeSelector;
